import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

// Import of loading-overlay components
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

// BootstrapVue imports
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-lazy-youtube-video/dist/style.css'
import './assets/css/bootstrap-yeti.min.css'
import './assets/css/style.css'

// VueSanitize import (Helps sanitize html user input from WYSIWYG editor)
import VueSanitize from 'vue-sanitize'

// Axios imports
import axios from './global-axios'

// Vuelidate form validation imports
import Vuelidate from 'vuelidate'

// Global Mixins imports
import ToastsMixins from './mixins/toastsMixins'

// BootstrapVue configuration
Vue.use(BootstrapVue, {
    // Toasts default options
    BToast: {
        toaster: 'b-toaster-bottom-right',
        autoHideDelay: 5000,
        variant: null,
        toastClass: null,
        headerClass: null,
        bodyClass: null
    }
})
Vue.use(BootstrapVueIcons)

// VueSanitize configuration
Vue.use(VueSanitize, {
    allowedTags: ['p', 'strong', 'em', 'u', 's', 'a'],
    allowedAttributes: {
        'a': ['href', 'rel', 'target', 'style']
    }
})

// loading-overlay configuration
Vue.use(Loading, {
    // props
    loader: 'spinner',
    width: 96,
    height: 96,
    color: '#4462b7',
    backgroundColor: '#eee',
    opacity: 0.8,
    zIndex: 5000
}, {
    // slots
    // after: 'Cargando...'
})

// Axios configuration
Vue.prototype.axios = axios

// Vuelidate form validation configuration
Vue.use(Vuelidate)

Vue.config.productionTip = false

// Configure global mixins, such as toasts messages and form validation functions
Vue.mixin({
    methods: {
        successToast: ToastsMixins.successToast,
        infoToast: ToastsMixins.infoToast,
        warningToast: ToastsMixins.warningToast,
        dangerToast: ToastsMixins.dangerToast,
        unknownErrorToast: ToastsMixins.unknownErrorToast
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
